<svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M16.321 23.9564C17.5132 23.9564 18.4782 22.9914 18.4782 21.7992V5.47819H14.1354C13.8232 5.47819 13.5961 5.22273 13.5961 4.93889V0H2.12883C0.96507 0 0 0.936685 0 2.12883V21.8276C0 22.9914 0.936685 23.9564 2.12883 23.9564H16.321ZM14.6748 0.851549V4.3996H17.8254L14.6748 0.851549Z"
        class="fill-brand" />
</svg>